import { render, staticRenderFns } from "./BatchUpload.vue?vue&type=template&id=358e2db1&"
import script from "./BatchUpload.vue?vue&type=script&lang=js&"
export * from "./BatchUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports